import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, toast } from '@/App';
import axios from 'axios';
import { LogIn } from 'lucide-react';
import Logo from '@/components/Logo';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      toast.success('Giriş başarılı!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error('Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="absolute inset-0 bg-gradient-to-br from-[#FF6B35]/10 via-transparent to-[#F7931E]/10"></div>
      
      <div className="w-full max-w-md relative z-10">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <Logo size="lg" />
          </div>
          <h1 className="text-3xl font-bold mb-2">Admin Paneli</h1>
          <p className="text-white/60">Giriş yapın</p>
        </div>

        <div className="glass p-8 rounded-2xl">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2">E-posta</label>
              <Input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="admin@eneryazilim.com"
                required
                data-testid="login-email-input"
                className="bg-white/5 border-white/10 text-white placeholder:text-white/40"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Şifre</label>
              <Input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="••••••••"
                required
                data-testid="login-password-input"
                className="bg-white/5 border-white/10 text-white placeholder:text-white/40"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full bg-gradient-to-r from-[#FF6B35] to-[#F7931E] hover:shadow-lg hover:shadow-[#FF6B35]/50 transition-all"
            >
              {loading ? 'Giriş yapılıyor...' : (
                <>
                  <LogIn className="w-4 h-4 mr-2" />
                  Giriş Yap
                </>
              )}
            </Button>
          </form>
        </div>

        <div className="mt-6 text-center text-sm text-white/60">
          <p>Varsayılan kullanıcı oluşturmak için kayıt endpoint'ini kullanın</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
